import { h } from '@stencil/core';
import cn from 'classnames';
import { ResizeObserver as ResizeObserverPolyfill } from '@juggle/resize-observer';
import { EQdsButtonImportance, EQdsButtonSize, pesIconMirrorDirection, pesIconSizes, PageNames } from '@pes-ui/utils';
import RouterLinkView from '../router-link-view';
import RouterQdsLinkView from '../router-qds-link-view';
import { isBrowser } from '../../../globals/utils';
import { isAppRoutingEnabled } from '../../pes-router/utils';
const ResizeObserver = window.ResizeObserver || ResizeObserverPolyfill;
export class MenuCategory {
  constructor() {
    this.asideRef = null;
    this.observer = null;
    this.handleAsideDidResize = () => {
      if (this.opened || !this.asideRef) {
        return;
      }
      this.menuWidth = window.getComputedStyle(this.asideRef).width;
    };
    this.handleMenuCategoryMouseEnter = (categoryId) => () => {
      if (!this.isMobile) {
        this.opened = true;
        this.activeCategoryId = categoryId;
        this.pdpMenuCategoryDidOpen.emit(categoryId);
      }
    };
    this.handleExitMenu = () => {
      this.opened = false;
      this.activeCategoryId = null;
      this.pdpMenuCategoryDidClose.emit();
    };
    this.getUrlSearchParams = (url, host = 'http://fake.host') => {
      const searchParams = {};
      new URL(url, host).searchParams.forEach((value, key) => {
        searchParams[key] = value;
      });
      return searchParams;
    };
    this.renderMenuItem = (el) => {
      const searchParams = this.getUrlSearchParams(el.url);
      return (h("li", { key: el.id, "data-category-id": el.id, onMouseEnter: this.handleMenuCategoryMouseEnter(el.id), class: cn('menu-category__item', {
          'menu-category__item--opened': this.activeCategoryId === el.id,
        }) }, h(RouterLinkView, { linkClassName: "menu-category__item-link", url: isAppRoutingEnabled() ? '' : el.url, page: "category", pageId: el.sourceId, urlSearchParams: searchParams, name: el.name, storageName: this.storageName, breadcrumbs: this.breadcrumbs, pageName: PageNames.CATEGORY }, h("span", { class: "menu-category__item-text" }, el.name), h("se-icon", { class: "menu-category__item-icon", size: pesIconSizes.NANO, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left"))));
    };
    this.renderMenuDetail = (el) => {
      var _a, _b;
      const category = (_a = this.business) === null || _a === void 0 ? void 0 : _a.find((c) => c.id === el.id);
      const hmcBanner = category === null || category === void 0 ? void 0 : category.hmcBanner;
      return (h("div", { onMouseEnter: this.handleMenuCategoryMouseEnter(el.id), class: cn('menu-category__details', {
          'menu-category__details--opened': this.activeCategoryId === el.id,
        }) }, !category ? (h("se-loading", { loading: true })) : (h("div", { class: "menu-category__details-section" }, h("pes-menu-cards", { categoryId: category.id, page: "range", title: this.topTangesLabel, viewOnLabel: this.viewOnLabel, productRelationsViewProdLabel: this.productRelationsViewProdLabel, list: category.toprunners, hmcBanner: hmcBanner, class: "line-categories", storageName: this.storageName, breadcrumbs: this.breadcrumbs }, h("div", { class: "view-all" }, h(RouterQdsLinkView, { url: isAppRoutingEnabled() ? '' : el.url, page: "category", pageId: el.sourceId, size: EQdsButtonSize.SMALL, importance: EQdsButtonImportance.EMPHASIZED, name: el.name, storageName: this.storageName, breadcrumbs: this.breadcrumbs, pageName: PageNames.CATEGORY }, this.seeAllOffersLink))))), ((_b = category === null || category === void 0 ? void 0 : category.products) === null || _b === void 0 ? void 0 : _b.length) > 0 && (h("div", { class: "menu-category__details-section" }, h("pes-menu-cards", { categoryId: category.id, page: "product", title: this.mostViewedProductsLabel, viewOnLabel: this.viewOnLabel, productRelationsViewProdLabel: this.productRelationsViewProdLabel, list: category.products, class: "line-categories", variant: "small", commerceConnectorSettings: this.commerceConnectorSettings, storageName: this.storageName, breadcrumbs: this.breadcrumbs })))));
    };
    this.menuList = undefined;
    this.topTangesLabel = undefined;
    this.viewOnLabel = undefined;
    this.productRelationsViewProdLabel = undefined;
    this.seeAllOffersLink = undefined;
    this.mostViewedProductsLabel = undefined;
    this.business = undefined;
    this.isMobile = false;
    this.commerceConnectorSettings = undefined;
    this.isPBS = false;
    this.host = undefined;
    this.breadcrumbs = undefined;
    this.storageName = undefined;
    this.activeCategoryId = null;
    this.menuWidth = null;
    this.opened = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentDidLoad() {
    if (isBrowser() && this.asideRef) {
      this.observer = new ResizeObserver(this.handleAsideDidResize);
      this.observer.observe(this.asideRef);
    }
  }
  getListStyles() {
    return this.opened && this.menuWidth ? { width: this.menuWidth, minWidth: this.menuWidth } : {};
  }
  render() {
    var _a, _b;
    const detail = (_a = this.menuList) === null || _a === void 0 ? void 0 : _a.find((item) => item.id === this.activeCategoryId);
    return (h("aside", { ref: (el) => (this.asideRef = el), onMouseLeave: this.handleExitMenu, class: cn('menu-category', {
        'menu-category--opened': this.opened,
      }) }, h("ul", { style: this.getListStyles(), class: "menu-category__list" }, (_b = this.menuList) === null || _b === void 0 ? void 0 : _b.map(this.renderMenuItem)), h("div", { class: "menu-category__details-container" }, detail && this.renderMenuDetail(detail))));
  }
  static get is() { return "pes-menu-category"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["menu-category.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["menu-category.css"]
    };
  }
  static get properties() {
    return {
      "menuList": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CategoriesApi.ProductsAllCategories[]",
          "resolved": "ProductsAllCategories[]",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "topTangesLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "top-tanges-label",
        "reflect": false
      },
      "viewOnLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "view-on-label",
        "reflect": false
      },
      "productRelationsViewProdLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-relations-view-prod-label",
        "reflect": false
      },
      "seeAllOffersLink": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "see-all-offers-link",
        "reflect": false
      },
      "mostViewedProductsLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "most-viewed-products-label",
        "reflect": false
      },
      "business": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CategoriesApi.ProductsAllCategoriesCategory[]",
          "resolved": "ProductsAllCategoriesCategory[]",
          "references": {
            "CategoriesApi": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isMobile": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-mobile",
        "reflect": false,
        "defaultValue": "false"
      },
      "commerceConnectorSettings": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "CommerceConnectorSettings",
          "resolved": "{ options: CommerceConnectorOptions; labels: CommerceConnectorLabels; messages: CommerceConnectorMessages; }",
          "references": {
            "CommerceConnectorSettings": {
              "location": "import",
              "path": "../../commerce-connector/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether the component is integrated to PBS."
        },
        "attribute": "is-p-b-s",
        "reflect": false,
        "defaultValue": "false"
      },
      "host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "host",
        "reflect": false
      },
      "breadcrumbs": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TBreadcrumbs[]",
          "resolved": "TBreadcrumbs[]",
          "references": {
            "TBreadcrumbs": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "breadcrumbs array for saving in indexDB"
        }
      },
      "storageName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "storageName in indexDB for saving breadcrumbs"
        },
        "attribute": "storage-name",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "activeCategoryId": {},
      "menuWidth": {},
      "opened": {}
    };
  }
  static get events() {
    return [{
        "method": "pdpMenuCategoryDidOpen",
        "name": "pdpMenuCategoryDidOpen",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "string | null",
          "resolved": "string",
          "references": {}
        }
      }, {
        "method": "pdpMenuCategoryDidClose",
        "name": "pdpMenuCategoryDidClose",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "void",
          "resolved": "void",
          "references": {}
        }
      }];
  }
  static get elementRef() { return "el"; }
}
